import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/billing` is a section of `/settings` now (block 31 override of C6). Kept as a
 * redirect forever: sent emails, WhatsApp replies, the shipped extension and
 * live Dodo sessions all link here.
 */
export const Route = createFileRoute("/_authed/billing/")({
  validateSearch: (search): { checkout?: "cancelled" } => (search.checkout === "cancelled" ? { checkout: "cancelled" } : {}),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/settings", search, hash: "billing" })
  },
})
